import { createSlice } from "@reduxjs/toolkit";
export const initialState = {
  status: "idle",
  error: null,
  success: false,
  isStaff: false,
  isStudent: false,
  isParent: false,
};
const whoIsTheUserSlice = createSlice({
  name: "whoIsTheUser",
  initialState,
  reducers: {
    // Other reducers if necessary
    setWhoIsTheUser(state, action) {
      const { isAuthenticated, roles = [] } = action.payload || {};
      if (!isAuthenticated) return;
        console.log("roles", roles);
        const isParent = (roles || []).includes("Parent");
        console.log("isParent", isParent);
        state.isParent = isParent;

        const isStudent = (roles || []).includes("Student");
        console.log("isStudent", isStudent);
        state.isStudent = isStudent;
        state.isStaff = roles.some(
          (role) => role !== "Parent" && role !== "Student"
        );
        console.log("isParent", isParent);
        console.log("isStaff", state.isStaff);
        console.log("isStudent", isStudent);
    },

    setError(state, action) {
      state.error = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
    clearSuccess(state) {
      state.success = false;
    },
  },
});
export const { setWhoIsTheUser, setError, clearError, clearSuccess } =
  whoIsTheUserSlice.actions;
export default whoIsTheUserSlice.reducer;
